<template>
  <div class="footer">
    <div class="left-footer">
      <a class="resume" :href="resume" target="_blank"><div class="resume-link">Resume PDF</div></a>
    </div>
    <div class="copyright">
      <p> &copy;Animesh 2017</p>
    </div>
    <div class="right-footer">
      <a class="link" :href="github" target="_blank"><i class="fa fa-github"></i></a>
      <a class="link" :href="linkedin" target="_blank"><i class="fa fa-linkedin"></i></a>
    </div>
  </div>
</template>

<style type="text/css">
  .footer{
    margin-left: -50px;
    margin-right: -50px;
    margin-bottom: -50px;
    background-color: #fff;
    padding: 20px;
  }
  .left-footer, .right-footer, .copyright {
    display: inline-block;
    width: 32%;
    text-align: center;
  }
  .copyright {
    font-family: 'Roboto-Regular', sans-serif;
    font-size: 12px;
    color: #ccc;
  }
  .right-footer {
    text-align: center;
  }
  .right-footer .link {
    display: inline-block;
    color: white;
    background: #000000; /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #000000, #434343); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #000000, #434343); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  }
  .link {
    display: block;
    background: #56ccf2; /* fallback for old browsers */
    width: 50px;
    text-align: center;
    padding: 10px 0px;
    border-radius: 60px;
    color: white;
  }
  a.resume:hover {

  }
  a.resume .resume-link {
    font-weight: 700;
    font-size: 14px;
    text-transform: uppercase;
  }
  @media screen and (max-width: 400px) {
    .footer {
      margin: 0
    }
    .left-footer, .right-footer, .copyright {
      display: block;
      width: 100%;
    }
  }
</style>

<script>

  import resume from '../../assets/Animesh_Manglik_Resume_2017.pdf';

  export default {
    name: 'footer',
    data() {
      return {
        github: 'https://github.com/animeshmanglik',
        linkedin: 'https://www.linkedin.com/in/animeshmanglik',
        resume,
      };
    },
  };
</script>


// WEBPACK FOOTER //
// Footer.vue?3fc8f278